export default "__VITE_ASSET__C$9DkJB7__"